import React from 'react';
import CrewList from './CrewList';

export default props => <CrewList {...props} />;
